import React, { memo, useRef } from 'react';
import { LeadPopGame } from 'lead-pop';

/**
 * Embeds lead-pop during ENRICHING. No round timer; ends when `sessionComplete` is true.
 * @param {{
 *   literals: Record<string, string>,
 *   sessionComplete: boolean,
 *   onViewProspectingResults: () => void,
 *   enrichmentProgress?: { current: number, total: number },
 *   backendLeadSignal?: object | null,
 * }} props
 */
function LeadPopEnrichingPanel({
    literals,
    sessionComplete,
    onViewProspectingResults,
    enrichmentProgress,
    backendLeadSignal,
}) {
    const gameRef = useRef(null);

    return (
        <div className="fm-leads-modal__lead-pop-host">
            <LeadPopGame
                ref={gameRef}
                useDurationLimit={false}
                sessionComplete={sessionComplete}
                onPrimaryResultAction={onViewProspectingResults}
                difficulty="normal"
                autoStart
                showStartBanner
                literals={literals}
                enrichmentProgress={enrichmentProgress}
                backendLeadSignal={backendLeadSignal}
            />
        </div>
    );
}

export default memo(LeadPopEnrichingPanel);
